import React from 'react'
import './Footer.scss'

export default function Footer() {
  return (
    <footer id="site-footer">
      &copy; {new Date().getFullYear()} Rob Bayliss
    </footer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Footer.js